module.exports = __webpack_public_path__ + "static/media/one-bed-spacious-bg-1.657e3964.jpg";